import React, { createContext, useContext, useState, useEffect } from 'react';

const CursorContext = createContext(null);

export const useCursor = () => {
  const context = useContext(CursorContext);
  if (!context) {
    return { setLabel: () => {}, mousePos: { x: -100, y: -100 }, label: '', isTouch: true };
  }
  return context;
};

export const CursorProvider = ({ children }) => {
  const [mousePos, setMousePos] = useState({ x: -100, y: -100 });
  const [label, setLabel] = useState('');
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    setIsTouch(isTouchDevice);

    if (!isTouchDevice) {
      const handleMove = (e) => setMousePos({ x: e.clientX, y: e.clientY });
      window.addEventListener('mousemove', handleMove);
      return () => window.removeEventListener('mousemove', handleMove);
    }
  }, []);

  return (
    <CursorContext.Provider value={{ mousePos, label, setLabel, isTouch }}>
      {children}
    </CursorContext.Provider>
  );
};
